module.exports = __webpack_public_path__ + "static/media/me3_ECAP_Achievements_Icon.2464e6ef.svg";